import '@abraham/reflection'
import { createApp } from 'vue'
import { Component, VueComponent } from 'vue3-oop'
import { RouterView } from 'vue-router'
import RouterStart from '@/router'
import { HttpInterceptor } from '@/api/http.interceptor'
import { setup } from '@/setup'
import './theme/main.scss'
import { ConfigProvider } from 'ant-design-vue'
import zh_CN from 'ant-design-vue/lib/locale/zh_CN'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import 'ant-design-vue/dist/antd.css'
import './common.scss'
import { sameDomain } from './common/util/ifreamConfig'
import { RouterService } from '@/router/router.service'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'

@Component({ providers: [RouterStart, HttpInterceptor, RouterService] })
class App extends VueComponent {
  render() {
    return (
      <ConfigProvider locale={zh_CN}>
        <RouterView />
      </ConfigProvider>
    )
  }
}

sameDomain()
dayjs.locale('zh-cn')
const app = createApp(App)
setup(app)
app.use(VXETable).mount('#app')
